  
import Navbar from './Navbar.vue'
import Verfiy from './verify.vue'
import Dashboard from './Dashboard.vue'


export { Dashboard, Verfiy }


// WEBPACK FOOTER //
// ./src/pages/dashboard/index.js